// @ts-strict-ignore
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UI_STRINGS } from '../../../../functions/language/uistrings';
import { TranslateStringPipe } from '../../../../pipes/translate-string/translate-string.pipe';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    imports: [CommonModule, TranslateStringPipe]
})
export class LoadingSpinnerComponent {
  @Input() message: string;
  UI_STRINGS = UI_STRINGS.GLOBAL;
}
